import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  FindPartnerPathForSyncProductsType,
  FindPathFromCentralEntityToTargetEntityType,
  PartnerPathApi,
} from 'api';

export const findSupplierEntity = createAsyncThunk(
  'partnerPath/findSupplierEntity',
  async (any, { rejectWithValue }) => {
    try {
      const response = await PartnerPathApi.findSupplierEntity();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCustomerEntity = createAsyncThunk(
  'partnerPath/findCustomerEntity',
  async (shouldDisplayCustomerPartner: boolean, { rejectWithValue }) => {
    try {
      const response = await PartnerPathApi.findCustomerEntity(
        shouldDisplayCustomerPartner
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findPartnerPathForSyncProduct = createAsyncThunk(
  'partnerPath/findPartnerPathForSyncProduct',
  async (option: FindPartnerPathForSyncProductsType, { rejectWithValue }) => {
    try {
      const response = await PartnerPathApi.findPartnerPathForSyncProduct(
        option
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findChainEntity = createAsyncThunk(
  'partnerPath/findChainEntity',
  async (any, { rejectWithValue }) => {
    try {
      const response = await PartnerPathApi.findChainEntity();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findPathToEntity = createAsyncThunk(
  'partnerPath/findPathToEntity',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await PartnerPathApi.findPathToEntity(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findPathFromCentralEntityToTargetEntity = createAsyncThunk(
  'partnerPath/findPathFromCentralEntityToTargetEntity',
  async (
    option: FindPathFromCentralEntityToTargetEntityType,
    { rejectWithValue }
  ) => {
    try {
      const response =
        await PartnerPathApi.findPathFromCentralEntityToTargetEntity(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

const partnerPathSlice = createSlice({
  name: 'partnerPath',
  initialState: {},
  reducers: {},
});

const { reducer: partnerPathReducer } = partnerPathSlice;

export default partnerPathReducer;
